











































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalBackofficeNacionalidade extends Vue {
  $refs!: { formNacionalidade: any }

  loadingPendenciaNacionalidade = false
  formNacionalidadeRules: any = {
    valid: true,
    nacionalidade: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get showModalPendenciaNacionalidade() { return this.getBackofficeGlobalStore.modal.pais }
  set showModalPendenciaNacionalidade(value: boolean) { this.getBackofficeGlobalStore.setModal({ name: 'pais', value }) }

  async resolvePendenciaNacionalidade() {
    this.loadingPendenciaNacionalidade = true
    if (this.$refs.formNacionalidade.validate()) {
      const params: any = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        adicionaPacienteNoHis: false,
        paisId: this.getBackofficeGlobalStore.solicitacao.paciente.paisId,
      }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const response = await this.getBackofficeGlobalStore.backofficeAgendamentoAdicionarPaciente(params)

      if (!response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Não foi possivel atualizar o paciente',
          icon: 'warning',
          color: '#C62828',
        })
        this.loadingPendenciaNacionalidade = false
        return
      }

      EventBus.$emit('setSnackbar', { show: true, text: 'Paciente atualizado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getBackofficeGlobalStore.setSolicitacaoFields({ field: 'temPendenciaDePacientePais', value: false })
      this.showModalPendenciaNacionalidade = false
    }
    this.loadingPendenciaNacionalidade = false
  }

  @Watch('showModalPendenciaNacionalidade')
  onChangeShowModalPendenciaNacionalidade(value: boolean) {
    if (!value) {
      this.$nextTick(() => {
        if (!!this.$refs.formNacionalidade) this.$refs.formNacionalidade.resetValidation()
      })
    }
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
}
